import { useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import BasicDialog from "../../base/BasicDialog";
import AutocompleteField from "../../field/AutocompleteField";
import { Button, Grid } from "@mui/material";

const SelectCurrencyDialog = (props) => {
  const { t } = useTranslation();

  const [selectedCurrency, setSelectedCurrency] = useState();



  const onChangeAutocompleteFieldWithObjectOptions = (
    e,
    value_object,
    value_key,
    state_value_name
  ) => {
    const newFormValue = Array.isArray(value_object)
      ? value_object.map((option) =>
          typeof option === "object" ? option[value_key] : option
        )
      : value_object[value_key];
    setSelectedCurrency(newFormValue);
  };


  const getDialogContent = () => {
    return (
      <>

          <Grid item xs={12}>
            <AutocompleteField
              name={"currency_name"}
              label={t("dialog.select_currency_dialog.currency_name")}
              value={selectedCurrency}
              options={props.selectCurrencyDialogList}
              isObjectOption={true}
              optionLabelKey={"currency_name"}
              addNewValue={false}
              onChange={onChangeAutocompleteFieldWithObjectOptions}
              required
            />
          </Grid>
        <Button
          sx={{ marginTop: "20px" }}
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => props.onSubmit(selectedCurrency)}
          disabled={!selectedCurrency}
        >
          {t("select")}
        </Button>
      </>
    );
  };

  return (
    <BasicDialog
      open={props.open}
      onClose={props.onClose}
      titleAlign="center"
      maxWidth="xs"
      title={t("dialog.select_currency_dialog.select_currency")}
    >
      {getDialogContent()}
    </BasicDialog>
  );
};

SelectCurrencyDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  selectCurrencyDialogList: PropTypes.array,
};

SelectCurrencyDialog.defaultProps = {
  selectCurrencyDialogList: [],
};

export default SelectCurrencyDialog;
